import { Injectable } from '@angular/core';
import {CustomerService} from '../auth/services/customer.service';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of as observableOf} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerChildrenResolveService implements Resolve<any> {

  constructor(private customerService: CustomerService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
      if (this.customerService.institution.customerType === 'District') {
        const institutionId = Number.parseInt(route.paramMap.get('institutionId'), 10);
        return this.customerService.getChildrenWithChildStatus(institutionId).pipe(map(
            res => {
              this.customerService.childInstitutions = res;
              return res;
            } , () => {
              return observableOf([]);
            }
        ));
      } else {
        return observableOf([]);
      }
    }
}
